import { useNavigate } from 'react-router';
import {
  Divider,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from '@mui/material';

import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import { useAuth } from '../../providers/AuthContext';
import APP_ROLES from '../AppRoles';

interface SidebarContentProps {
  toggleDrawer: () => void;
}

function SidebarContent({
  toggleDrawer,
}: SidebarContentProps): React.JSX.Element | null {
  const navigate = useNavigate();
  const auth = useAuth();

  if (!auth.user) {
    return null;
  }

  if (!(auth?.roles || []).includes(APP_ROLES.ADMIN_ACCQSURE)) {
    return null;
  }

  return (
    <>
      <List component='nav'>
        <ListItemButton
          onClick={() => {
            navigate('/organizations');
            toggleDrawer();
          }}
        >
          <ListItemIcon>
            <EngineeringOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Organizations' />
        </ListItemButton>
      </List>

      <Divider sx={{ my: 1 }} />
    </>
  );
}

export default SidebarContent;
